import { format } from 'date-fns'

import { i18nDateToString } from 'modules/core/lib/dates'
import type { View } from 'modules/shift_management/lib/types'

const formatHeader = (date: Date, view: View, isTimeFormat24H: boolean) => {
  if (view.isDaily) {
    return isTimeFormat24H ? format(date, 'HH') : format(date, 'ha')
  }

  const shortDate = i18nDateToString(date, 'ui_short')
  if (view.isWeekly) return shortDate
  return format(date, 'd') + ' ' + shortDate.slice(0, 2)
}

export { formatHeader }
